var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-16"},[(!_vm.isB2u)?_c('mia-settings-basics-texts-general-form'):_vm._e(),_c('mia-has-feature',{attrs:{"feature":"connect_onboarding"}},[_c('mia-texts-connect-onboarding-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }